import { useState } from 'react';
import { X } from 'lucide-react';
import { IMG } from '../data';

const GALLERY = [
  { url: IMG.hero, label: 'Luxury Sedan' },
  { url: IMG.luxury1, label: 'Sports Coupe' },
  { url: IMG.lexusExterior, label: 'Lexus Premium Wash' },
  { url: IMG.lexusInterior, label: 'Lexus Premium Interior' },
  { url: IMG.premiumInterior, label: 'Premium Interior Detail' },
  { url: IMG.premiumExterior, label: 'Premium Exterior Detail' },
  { url: IMG.interior, label: 'Mercedes Interior' },
  { url: IMG.luxury2, label: 'Premium Exterior' },
  { url: IMG.truckDetail, label: 'Truck Clay and Wax Wash' },
  { url: IMG.suv, label: 'SUV Detail' },
  { url: IMG.wheel, label: 'Wheels and Tires' },
  { url: IMG.carWash, label: 'Exterior Wash' },
];

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <div data-testid="gallery-page" className="pt-32 pb-24 bg-[#0a0a0a] text-white min-h-screen">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <span className="pill mb-4">Gallery</span>
        <h1 className="font-display font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter max-w-3xl">Every vehicle deserves the spotlight.</h1>
        <p className="text-zinc-400 max-w-2xl mt-5 text-lg">A look at our recent work — luxury, sport, family and work vehicles across Lincoln.</p>

        <div className="masonry mt-16">
          {GALLERY.map((g, i) => (
            <button
              key={i}
              data-testid={`gallery-item-${i}`}
              onClick={() => setActive(g)}
              className="block w-full overflow-hidden rounded-2xl group relative"
            >
              <img src={g.url} alt={g.label} loading="lazy" className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <span className="text-white text-sm font-medium">{g.label}</span>
              </div>
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div data-testid="lightbox" className="fixed inset-0 z-[60] bg-black/95 flex items-center justify-center p-6" onClick={() => setActive(null)}>
          <button onClick={() => setActive(null)} className="absolute top-6 right-6 text-white p-2 rounded-full hover:bg-white/10" data-testid="lightbox-close">
            <X />
          </button>
          <img src={active.url} alt={active.label} className="max-w-full max-h-full rounded-2xl" />
        </div>
      )}
    </div>
  );
}
